const firebaseConfig = {
    apiKey: "AIzaSyCLTezRyogG4-NWk-mz3EScoyxXinN7YpU",
    authDomain: "volunteernetwork-2bb3d.firebaseapp.com",
    databaseURL: "https://volunteernetwork-2bb3d.firebaseio.com",
    projectId: "volunteernetwork-2bb3d",
    storageBucket: "volunteernetwork-2bb3d.appspot.com",
    messagingSenderId: "333302266192",
    appId: "1:333302266192:web:7ba58bd47212ed5bd4d455"
  };
  export default firebaseConfig ;